import { componentByType } from "@constant";

export const getComponentByType = (componentType: string) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  /* @ts-ignore*/
  if (!componentByType[componentType]) {
    console.error(`componentType type ${componentType} not found`);
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  /* @ts-ignore*/
  return componentByType[componentType];
};
